module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nnn-8cd1c36689a8ed3d13630f7a8a270e17.png";